// 面包屑
export const UPDATE_BREADCRUMB = 'UPDATE_BREADCRUMB'
// 侧边栏
export const UPDATE_SUBMENU = 'UPDATE_SUBMENU'

// 获取公司信息
export const GET_BASIC_SUCCESS = 'GET_BASIC_SUCCESS'
export const GET_BASIC_FAILED = 'GET_BASIC_FAILED'
